<template>
  <div class="loginEn-page ui-login login" :style="{height: mobileHeight + 'px'}">
    <div class="loginMain" :style="{height: (bodyHeight < 740 ? 635 : bodyHeight - 105) + 'px'}">
      <div v-show="switchPrompt" class="purchaserMask hidden-xs hidden-sm" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.75);position: fixed;z-index: 1052;top: 0px;left: 0px;"></div>
      <div class="loginCon hidden-xs">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/login_logo.png" alt="" @click="jump">
      </div>
      <form class="el-form" v-loading="loading">
        <h3>Login</h3>
        <div class="el-form-item">
          <div class="el-form-item__content">
            <div class="el-input el-input--prefix">
              <input type="text" autocomplete="off" placeholder="Username" class="el-input__inner"v-model.trim="loginForm.userName" @keyup.enter="login()">
              <span class="el-input__prefix">
                <i class="el-input__icon"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/user_icon.png" alt=""></i>
              </span>
            </div>
          </div>
        </div>
        <div class="el-form-item">
          <div class="el-form-item__content">
            <div class="el-input el-input--prefix">
              <input type="password" autocomplete="off" placeholder="Password" class="el-input__inner" v-model.trim="loginForm.password" @keyup.enter="login()">
              <span class="el-input__prefix">
                <i class="el-input__icon"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/password_icon.png" alt=""></i>
              </span>
            </div>
          </div>
        </div>
        <div class="el-form-item verifyCode" v-if="loginFailNumber>3">
          <div class="el-form-item__content">
            <div class="el-input el-input--prefix clearfix">
              <input type="text" class="el-input__inner pull-left" placeholder="Verification code"   ref="verifyCode" v-model="loginForm.verifyCode"  @keyup.enter="login()" />
              <span class="el-input__prefix"  style="height: 48px;">
                <i class="el-input__icon">
                  <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/verifyCode_icon.png" alt="">
                </i>
              </span>
              <img id="verifyCode" class="pull-left" :src="verrifyCodeUrl" alt="The verification code failed to load. Please try again." @click="changeVerifyCode()">
              <a @click="changeVerifyCode()" class="verrifyChange pull-left"></a>
            </div>
          </div>
        </div>


        <div class="passwordSet hidden-xs clearfix">
          <el-checkbox id="checkbox" name="checkbox"  v-model="loginForm.rememeberPassword" @click="checkItem($event)"  @keyup.enter.native="login()">Remember me</el-checkbox>
        </div>
        <button type="button" class="el-button el-button--primary" @click="login()"><span>Login</span></button>
        <p class="leadStep hidden-xs">
          <transition name="el-fade-in">
            <div class="purchaserLeadStep" v-show="switchPrompt">
              <p>New version has launched，click to login<el-checkbox v-model="checkedPrompt">Stop prompt</el-checkbox><br></p>
              <el-button @click.stop="toNewSite">Close</el-button>
              <div class="leadArrowDown">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
              </div>
            </div>
          </transition>
          <a href="https://ebs.onelinkplus.com/uaa/login">Login to the new system</a>
        </p>
        <p class="hidden-xs">New customer? Start here. <span class="hidden-xs txt-blue cursor-pointer" @click="goCustomerService">Need help?</span></p>
<!--        <p class="hidden-xs txt-blue cursor-pointer" @click="goCustomerService">Need help?</p>-->
        <p class="cursor-pointer toggle-lang" @click="$router.push('/login')">切换中文版</p>
      </form>
    </div>
    <div class="footerBottom">
      <p>
        <span style="cursor: pointer">
          <a href="http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&serial=9031000020180928141425000002866592-SAIC_SHOW_310000-2018122018594033566&signData=MEYCIQCnB/Y+kI/GVR1Y8azeek7w7m7dnx1ziJ82bb+bl/0jBwIhAJMECiAYasxbH+nRD7qS1010iwZUN6zgz3xWGmv8fHqC" target="_blank">
            <img :src="webConfigInfo.businessCertificationAttachmentUrl" alt="">{{webConfigInfo.websiteAuthorization}} All rights reserved
          </a>
        </span>
      </p>
      <p>
        <span style="cursor: pointer"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/ghs.png" alt=""><a stle="text-decoration:none" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002003624" target="view_window">公安备案号：31011002003624</a></span>
        <span><a stle="text-decoration:none" href="https://beian.miit.gov.cn" target="view_window">备案证书号：沪ICP备05004652号-8</a></span>
        <span ><a stle="text-decoration:none" href="https://beian.miit.gov.cn" target="view_window">增值电信业务经营许可证：沪B2-20190630</a></span>
      </p>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import Cookies from 'js-cookie'
  export default {
    data () {
      return {
        loading: false,
        webConfigInfo: {},
        loginForm: {
          userName: '',
          password: '',
          rememeberPassword: false
        },
        loginFailNumber: 0,
        verrifyCodeUrl: '',
        redirectURL: '',  // 重定向地址
        bodyHeight: '100%',
        mobileHeight: '100%',
        switchPrompt:true,
        checkedPrompt:false
      }
    },
    components: {
    },
    computed: mapState([
      'KP'
    ]),
    created () {
      let query = this.$route.query;
      this.redirectURL = query.redirectURL ? decodeURIComponent(query.redirectURL) : '';
      this.loginFailNumber = this.getToken('loginFailNumber');
      this.findMainCommonInfo()
      if(this.getToken('isRemember') == 100){
        let rememberInfo = JSON.parse(this.getDAesString(this.getToken('rememberInfo'),this.KP.key,this.KP.iv));
        this.loginForm.userName  = rememberInfo.userName;
        // 如果是修改密码回来的 去掉密码
        if ((!this.$route.query.isReset) && this.$route.query.isReset != '1') {
          this.loginForm.password  = rememberInfo.password;
        }
        this.loginForm.rememeberPassword = true;
      };
      this.showPrompt();
    },
    mounted () {
      this.resizeBody();
      window.onresize = () => this.resizeBody();
    },
    methods: {
      jump(){
        this.$router.push({path:"/"})
      },
      resizeBody(){
        this.bodyHeight = document.body.clientHeight;
      },
      // 更新验证码
      changeVerifyCode() {
        let img = document.getElementById("verifyCode");
        img.src = this.verrifyCodeUrl + "?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
        this.loginForm.verifyCode = "";
      },

      // 获取公共信息
      findMainCommonInfo() {
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {}).then((res) => {
          let data = res.data;
          this.webConfigInfo = data.webConfigInfoDto;
          this.footerColumnInfos = data.footerColumnInfos;
          this.navigationColumnInfos = data.navigationColumnInfos;
          this.hitSearchUrl = data.hitSearchUrl;
          this.yellowPageColumn = data.yellowPageColumn;
          this.productAndSolutionColumn = data.productAndSolutionColumn;
          this.enterpriseResourceBaseUrl = data.enterpriseResourceBaseUrl;
          this.verrifyCodeUrl = data.verrifyCodeUrl + "?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
        }).catch((err) => {
          console.log(err)
        })
      },

      // 登录
      login() {
        if (!this.loginForm.userName) {
          this.$message.error('Please enter accout')
          return false;
        }
        if (this.loginForm.password.length < 6 || this.loginForm.password.length > 20) {
          this.$message.error('Password must be within 6-20 characters,please re-enter');
          return false;
        }
        if (this.loginFailNumber <= 3) {
          this.loginForm.verifyCode = ''
        }
        if (this.loginFailNumber > 3 && !this.loginForm.verifyCode) {
          this.$message.error('Please enter verification code');
          return false;
        }

        let params = {...this.loginForm, openId: this.$route.query.openId || ''}
        this.loading = true
        this.$axios.post('/onelink.mdata.main.api/user/login', params).then((res) => {
          this.loading = false
          //登录标记
          let data = res.data
          let loginFlag = data.loginFlag;
          //登录失败次数
          this.loginFailNumber = data.loginFailNumber;
          // 如果登录成功重定义跳转
          if (loginFlag) {
            if (!this.isLoginEn(data.uCenterOrgGroupDtos)) {
              // 跳转中文登录存登录信息
              this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.loginForm),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.loginForm),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
              if(this.loginForm.rememeberPassword) {
                this.setToken('isRemember',100);
                Cookies.set('isRemember',100);
              } else {
                this.setToken('isRemember','');
                Cookies.set('isRemember','',{domain:'.onelinkplus.com',expires:10});
              }
              let alertText = `<div>您不是海外版用户，请使用中文版登录 </br> You're not International version user, please switch to Chinese version</div>`
              this.$alert(alertText, '提示 Alert', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定 (OK)',
                callback: action => {
                  this.$router.push({path: '/login', query: {type: 'en'}})
                }
              });
            } else {
              this.loginSuccess(data)
            }
          } else {
            this.setToken('isRemember','');
            let userInfo = data.uCenterMemberInforDto || {}
            let queryInfo = {
              userId: userInfo.id,
              email: userInfo.email,
              companyId: userInfo.companyId,
              companyName: userInfo.companyName,
              orgIdentity: userInfo.orgIdentity,
              regAddrType: userInfo.regAddrType,
              createUserId: userInfo.createUserId
            }
            if(data.errorInfo == '该账户正在审核中'){
              this.$message.error('This account is under review');
              this.$router.push({
                path:"registerExamine",
                query:{
                  ...queryInfo,
                  trueName: userInfo.trueName,
                }});
            } if(data.errorInfo == '该账户审批未通过'){
              this.$message.error('The account approval failed');
              this.$router.push({
                path:"registerFailed",
                query:{
                  ...queryInfo,
                  regeisterType: data.registerType,
                  exmaineMessage: data.checkCardInfo && data.checkCardInfo.checkRemark
                }});
            } else if (data.errorInfo == '该微信账号已经与其他一链网账户绑定') {
              this.$message.error('The WeChat account has been already bound to another OneLinkPlus account');
            } else if (data.errorInfo == '登录失败！失败原因为：密码不匹配') {
              this.$message.error('Your password is incorrect.');
            } else {
              if (data.errorInfo == '验证码输入错误') {
                this.$message.error('Invalid verification code');
                this.loginForm.verifyCode = "";
              } else {
                // 用户名和密码不符
                this.$message.error('Login failed！Please contact the Cutomer Service.');
              }
              // else {
              //   console.log(data.errorInfo)
              //   this.$message.error(data.errorInfo);
              // }
              this.verrifyCodeUrl = this.verrifyCodeUrl + "?operateType=login_&?date=" + encodeURI(encodeURI(new Date()));
            }
          }
        }).catch((err) => {
          console.log(err)
        })
      },

      // 登录成功set
      loginSuccess (data) {
        // 设置语言
        Cookies.remove('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE');
        Cookies.set('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE','en_US',{domain:'.onelinkplus.com',expires:10});
        Cookies.set('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE2','en_US',{domain:'.onelinkplus.com',expires:10});
        // 登录状态
        this.setToken('isLogin', 100);
        this.setToken('messageNumber', this.getAesString(data.messageNumber,this.KP.key,this.KP.iv));
        // 登录后全部用户信息
        this.setToken('loginInfo', this.getAesString(JSON.stringify(data || {}), this.KP.key, this.KP.iv));
        // 用户信息
        this.setToken('userInfo', this.getAesString(JSON.stringify(data.uCenterMemberInforDto || {}), this.KP.key, this.KP.iv));
        // 公司信息
        this.setToken('companyInfo', this.getAesString(JSON.stringify(data.uCenterMemberInforDto.uCenterORGUserRelationsDto || {}), this.KP.key, this.KP.iv));
        Cookies.set('isLogin', 100, {domain: '.onelinkplus.com', expires: 10});

        this.RememberPassWord()
        if (!this.redirectURL) {
          // todo
          let url = window.location.href;
          let env = (/local.onelinkplus.com/.test(url) || /test/.test(url) ? "test-ebidding" : /uat/.test(url) ? "uat-ebidding" : "ebidding");
          location.href = `http://${env}.onelinkplus.com/epl/pur/exeplan/queryExeplan.htm?locale=en_US`
        } else {
          if (this.redirectURL.indexOf('http') == 0) {
            window.location.href = this.redirectURL;
          } else {
            this.$router.push({path: this.redirectURL});
          }
        }
      },

      // 记住密码
      RememberPassWord () {
        if(this.loginForm.rememeberPassword) {
          this.setToken('isRemember',100);
          this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.loginForm),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
          Cookies.set('isRemember',100);
          Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.loginForm),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com',expires:10});
        } else {
          this.setToken('isRemember','');
          Cookies.set('isRemember','',{domain:'.onelinkplus.com',expires:10});
        }
      },

      // 在线客服
      goCustomerService() {
        window.open('https://onelinkplus.udesk.cn/im_client/?web_plugin_id=52506&cur_title=%E4%B8%80%E9%93%BE%E7%BD%91&src_url=&cur_url=http%253A%252F%252Fex.onelinkplus.com%252Fportal%252Findex&pre_url=http%3A%2F%2Fex.onelinkplus.com%2Fportal%2Findex')
      },

      // 判断是否是海外企业群组
      isLoginEn (groupList) {
        groupList = groupList || []
        let result = false
        groupList.forEach((item) => {
          if (item.groupName === '海外企业群组') {
            result = true
          }
        })
        return result
      },
      // 关闭提示新一链入口的操作
      toNewSite() {
        this.switchPrompt = false;
        if(this.checkedPrompt){
          Cookies.set('noPrompt',this.checkedPrompt,{domain:'.onelinkplus.com',expires:10});
        }
      },
      // 判断是否显示新一链入口的提示
      showPrompt(){
        if(Cookies.get("noPrompt") == 'true'){
          this.switchPrompt = false;
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .loginEn-page{
    background: url(https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/login_en_bg.png) no-repeat 50%;
    background-size: cover;
    .loginMain .el-form .el-form-item.verifyCode .el-input--prefix>.el-input__inner {
      width: 60%;
    }
    .toggle-lang{
      &:hover{
        color: #333;
      }
    }
    .txt-blue{
      color: #3F88E0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/loginEn/index.vue